export const network_hid_map = [
    {hid: '756604737398243328', name: 'mintegral_int'},
    {hid: '761108337025613824', name: 'Twitter'},
    {hid: '765611936652984320', name: 'ref'},
    {hid: '869194728082505728', name: 'pointblk_int'},
    {hid: '184647584722190336', name: 'adkomo_int'},
    {hid: '234187180623265792', name: 'appgrowth_int'},
    {hid: '193654783976931328', name: 'adquantum'},
    {hid: '198158383604301824', name: 'Adside-Web-Traffic'},
    {hid: '202661983231672320', name: 'AdSide_Web_Traffic'},
    {hid: '211669182486413312', name: 'adsidemedia'},
    {hid: '216172782113783808', name: 'adsupme'},
    {hid: '220676381741154304', name: 'af_app_invites'},
    {hid: '225179981368524800', name: 'af_cross_promotion'},
    {hid: '378302368699121664', name: 'googleadwords_int'},
    {hid: '252201579132747776', name: 'Apple Search Ads'},
    {hid: '333266372425416704', name: 'facebook'},
    {hid: '261208778387488768', name: 'applovin_int'},
    {hid: '270215977642229760', name: 'appsflyer_sdk_test_int'},
    {hid: '333266372425416704', name: 'Facebook-ads'},
    {hid: '283726776524341248', name: 'bingsearch_int'},
    {hid: '292733975779082240', name: 'chartboosts2s_int'},
    {hid: '301741175033823232', name: 'clickrising_int'},
    {hid: '315251973915934720', name: 'dataliftretargeting_int'},
    {hid: '288230376151711744', name: 'bytedanceglobal_int'},
    {hid: '369295169444380672', name: 'Google Organic Search'},
    {hid: '382805968326492160', name: 'hasoffers_int'},
    {hid: '400820366835974144', name: 'Imported Devices'},
    {hid: '405323966463344640', name: 'invalid_media_source_name'},
    {hid: '409827566090715136', name: 'ironsource_int'},
    {hid: '261208778387488768', name: 'Applovin'},
    {hid: '184647584722190336', name: 'adkomolimited'},
    {hid: '427841964600197120', name: 'liftoff_int'},
    {hid: '432345564227567616', name: 'mail.ru_int'},
    {hid: '441352763482308608', name: 'mobvista_int'},
    {hid: '463870761619161088', name: 'openmygame'},
    {hid: '481885160128643072', name: 'pointblank'},
    {hid: '490892359383384064', name: 'referral'},
    {hid: '499899558638125056', name: 'restricted'},
    {hid: '720575940379279360', name: 'Unity Ads'},
    {hid: '513410357520236544', name: 'smartyads_int'},
    {hid: '720575940379279360', name: 'unityads_int'},
    {hid: '234187180623265792', name: 'AppGrowth'},
    {hid: '540431955284459520', name: 'test'},
    {hid: '378302368699121664', name: 'Google Ads ACI'},
    {hid: '333266372425416704', name: 'Off-Facebook Installs'},
    {hid: '333266372425416704', name: 'Facebook Installs'},
    {hid: '567453553048682496', name: 'trademob_int'},
    {hid: '576460752303423488', name: 'Unattributed'},
    {hid: '333266372425416704', name: 'Instagram Installs'},
    {hid: '333266372425416704', name: 'Facebook Ads'},
    {hid: '594475150812905472', name: 'Untrusted Devices'},
    {hid: '607985949695016960', name: 'vungle_int'},
    {hid: '445856363109679104', name: 'moloco_int'},
    {hid: '626000348204498944', name: 'yandexdirect_int'},
    {hid: '671036344478203904', name: 'zengarden'},
    {hid: '522417556774977536', name: 'snapchat_int'},
    {hid: '729583139634020352', name: 'spades_referral_android'},
    {hid: '819655132181430272', name: 'Adsterra'},
    {hid: '824158731808800768', name: 'adsterra_int'},
    {hid: '828662331436171264', name: 'atlas'},
    {hid: '887209126591987712', name: 'Kwai'},
    {hid: '896216325846728704', name: 'BigoAds'},
    {hid: '905223525101469696', name: 'appnext_int'},
    {hid: '378302368699121664', name: 'Google Ads Search'},
    {hid: '378302368699121664', name: 'Google Ads Display'},
    {hid: '909727124728840192', name: 'Start.io (startapp)'},
    {hid: '522417556774977536', name: 'Snapchat Audience Network'},
    {hid: '522417556774977536', name: 'Snapchat (Ad Spend)'},
    {hid: '409827566090715136', name: 'IronSource'},
    {hid: '288230376151711744', name: 'Tiktok Installs'},
    {hid: '288230376151711744', name: 'TikTok'},
    {hid: '522417556774977536', name: 'Snapchat Installs'},
    {hid: '0', name: 'Organic'},
    {hid: '0', name: ''},
].reduce((acc, i) => {
    acc.set(i.name.toLowerCase(), i.hid);
    return acc;
}, new Map<string, string>());
